import React, { useState, useEffect } from "react";
// Импорт картинки
import smartLivingImg from "../assets/why.jpg";
import { useTranslation } from "react-i18next"; // Импортируем хук перевода

const Why_Section = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const { t, i18n } = useTranslation();
  const list = t("whylist", { returnObjects: true });
  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isVisible = scrollPosition > 1200;

  // Выносим SVG в константу для чистоты кода
  const ArrowIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-chevron-right"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );

  return (
    <section>
      <section className="w-full h-auto py-[100px] px-5 flex flex-col lg:flex-row justify-center items-center overflow-hidden bg-white">
        {/* Левый блок: Изображение */}
        <div
          className={`w-full h-[250px] relative sm:h-[400px] md:h-[450px] lg:h-[550px] xl:w-[900px] xl:h-[700px] 
        rounded-[20px] bg-cover bg-center bg-no-repeat transition-all duration-1000 delay-200
         xl:mx-[60px]
        ${isVisible ? "opacity-100" : "opacity-0 scale-95"}`}
          style={{ backgroundImage: `url(${smartLivingImg})` }}
        >
          {/* Правый блок: Инфо */}

          <div className="bg-[#0058a3]/70 absolute w-[600px] max-md:hidden max-lg:w-full max-lg:static top-[60%] rounded-3xl backdrop-blur-lg text-white p-3">
            <p className="max-sm:text-sm">{t("whyinfo")}</p>
          </div>
        </div>
        <div className="bg-[#0058a3]/70 absolute w-[600px] md:hidden max-lg:w-full max-lg:static top-[60%] rounded-3xl backdrop-blur-lg text-white p-3">
          <p className="max-sm:text-sm">{t("whyinfo")}</p>
        </div>
        <div
          className={`w-full md:w-[450px] lg:w-[550px] xl:w-[600px] flex flex-col justify-center items-start p-5 max-sm:p-1 transition-all duration-1000 delay-500 xl:mx-[60px]
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[100px]"}`}
        >
          <div className="w-full">
            <h1 className="font-['Cormorant_Garamond'] whitespace-pre-line uppercase max-sm:text-xl text-[#0058a3] text-[28px] sm:text-[32px] lg:text-[40px] xl:text-[44px] font-light leading-tight tracking-[0.15em] text-center md:text-left">
              {t("Whysolarenergy")}
            </h1>
          </div>

          <div className="w-full grid grid-cols-1 gap-6 mt-10">
            {Array.isArray(list) && (
              <ul className="flex flex-col w-full items-start space-y-3">
                {list.map((item, i) => (
                  <li
                    key={i}
                    className="flex w-full items-center gap-2 text-[12px] sm:text-[14px] font-medium tracking-widest my-1 uppercase text-gray-800 cursor-default"
                  >
                    <span className="min-w-6 min-h-6 text-yellow-500">
                      <ArrowIcon />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </section>
    </section>
  );
};

export default Why_Section;
